import { Fragment } from 'react';
import { Avatar as AntAvatar, AvatarProps } from 'antd';
import styled from 'styled-components';
import { themeConfig, useThemeContext } from '@/shared/theme';
import { intialsFromName } from '@/shared/utils';

type Props = AvatarProps & {
  imageUrl?: string;
  title?: string;
  showWrapper?: boolean;
};

export const PageTitleBannerAvatarImage = ({
  imageUrl,
  title,
  showWrapper = true,
  ...rest
}: Props) => {
  const { theme } = useThemeContext();
  const Wrapper = showWrapper ? PageTitleBannerAvatarWrapper : Fragment;
  const wrapperProps = showWrapper
    ? { $borderColor: themeConfig[theme].colors.layoutBg }
    : {};

  return (
    <Wrapper {...wrapperProps}>
      <StyledAvatar
        $borderColor={themeConfig[theme].colors.text}
        $bgColor={themeConfig[theme].colors.bgBase}
        src={imageUrl}
        icon={
          !imageUrl && (
            <Initials $color={themeConfig[theme].colors.text}>
              {intialsFromName(title)}
            </Initials>
          )
        }
        {...rest}
      />
    </Wrapper>
  );
};

export const PageTitleBannerAvatarWrapper = styled.div<{
  $borderColor?: string;
}>`
  border: 4px solid ${({ $borderColor }) => $borderColor};
  position: relative;
  width: 150px;
  min-width: 150px;
  height: 150px;
  min-height: 150px;
  border-radius: 50%;
  margin-top: -105px;
  overflow: hidden;
`;

const StyledAvatar = styled(AntAvatar)<{
  $borderColor?: string;
  $bgColor?: string;
}>`
  background-color: ${({ $bgColor }) => $bgColor};
  border: 1px solid ${({ $borderColor }) => $borderColor};
  color: #000;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Initials = styled.div<{ $color?: string }>`
  color: ${({ $color }) => $color};
  font-size: 52px;
  font-weight: bold;
  text-transform: uppercase;
`;
